export default __webpack_public_path__ + "static/media/arrow.c1b5dca2.svg";